<template>
  <LayoutSite>
    <Formulario titulo="Escritorios" v-if="!frmcadastro">
      <v-card-title>
        <v-btn
          color="primary"
          dark
          class="mb-2"
          @click="openform('novo')"
          :disabled="!permissoes.escritorio_incluir"
        >Novo Escritório</v-btn>
        <v-spacer></v-spacer>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Pesquisar"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="items"
        :search="search"
        v-model="selected"
        locale="pt-BR"
      >
        <template v-slot:item="props">
          <tr @dblclick="openform('editar',props.item.id)">
            <td class="text-xs-right">{{ props.item.nome }}</td>
            <td class="text-xs-right">{{ props.item.cnpj }}</td>
            <td class="text-xs-right">{{ props.item.telefone }}</td>
            <td class="text-xs-right">{{ props.item.responsavel }}</td>
          </tr>
        </template>
        <v-alert
          slot="no-results"
          :value="true"
          color="error"
          icon="warning"
        >Sua Pesquisa por "{{ search }}" não encontrou registros.</v-alert>
      </v-data-table>
    </Formulario>

    <Formulario :titulo="titulo" v-if="frmcadastro">
      <v-form @submit.prevent="salvar()">
        <v-card-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="frmcadastro=false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <v-text-field label="Nome" autofocus v-model="escritorio.nome"></v-text-field>
            </v-col>
            <v-col cols="12" sm="4">
              <v-text-field label="CNPJ" v-model="escritorio.cnpj"></v-text-field>
            </v-col>
            <v-col cols="12" sm="4">
              <v-text-field label="Telefone" v-model="escritorio.telefone"></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-autocomplete
                label="Responsável"
                v-model="escritorio.responsavel_id"
                :items="usuarios"
                item-text="name"
                item-value="id"
              ></v-autocomplete>
            </v-col>
            <v-col cols="6">
              <v-switch
                v-model="escritorio.anexo_cliente"
                label="Anexar Prazos no Sistema do Cliente"
              ></v-switch>
            </v-col>
          </v-row>
          <v-alert
            dense
            outlined
            type="error"
            v-for="(erro, index) of erros"
            :key="index"
          >{{erro[0]}}</v-alert>
        </v-card-text>
        <v-card-actions>
          <v-btn
            depressed
            color="error"
            @click="confirmaExcluir()"
            v-if="excluir"
            :disabled="!permissoes.escritorio_excluir"
          >EXCLUIR</v-btn>
          <v-spacer></v-spacer>
          <v-btn
            depressed
            color="primary"
            type="submit"
            :disabled="!permissoes.escritorio_alterar"
          >SALVAR</v-btn>
        </v-card-actions>
        <template>
          <v-row justify="center">
            <v-dialog v-model="exclusao" persistent max-width="400">
              <v-card>
                <v-card-title class="headline">Atenção</v-card-title>
                <v-card-text>Deseja realmente excluir este escritório?</v-card-text>
                <v-card-actions>
                  <div class="flex-grow-1"></div>
                  <v-btn color="red darken-1" text @click="exclusao = false">NÃO</v-btn>

                  <v-btn color="blue darken-1" text @click="deletar()">SIM</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-row>
        </template>
      </v-form>
    </Formulario>
  </LayoutSite>
</template>

<script>
import LayoutSite from "@/components/layout/LayoutSite";
import Formulario from "@/components/Form";

export default {
  components: {
    LayoutSite,
    Formulario
  },
  data() {
    return {
      selected: [],
      search: "",
      headers: [
        { text: "Nome", value: "nome", align: "left" },
        { text: "CNPJ", value: "cnpj" },
        { text: "Telefone", value: "telefone" },
        { text: "Responsável", value: "responsavel" }
      ],
      items: [],
      frmcadastro: false,
      excluir: false,
      exclusao: false,
      titulo: String,
      usuarios: [],
      erros: [],
      escritorio: {
        id: 0,
        nome: "",
        cnpj: "",
        telefone: "",
        responsavel_id: 0,        
        anexo_cliente: false
      },
      permissoes: {
        escritorio: false,
        escritorio_incluir: false,
        escritorio_alterar: false,
        escritorio_excluir: false
      }
    };
  },
  created: function() {
    this.getData();

    let permAux = this.$store.getters.getPermissoes;

    if (permAux.ativo) {
      this.permissoes = permAux;
      if (!this.permissoes.escritorio) this.$router.push("/#");
    } else this.$router.push("/#");
  },
  methods: {
    getData: function() {
      this.$http
        .get(this.$urlAPI + "/escritorio", {
          headers: { authorization: "Bearer " + this.$store.getters.getToken }
        })
        .then(response => (this.items = response.data));

      this.$http
        .get(this.$urlAPI + "/usuario", {
          headers: { authorization: "Bearer " + this.$store.getters.getToken }
        })
        .then(response => (this.usuarios = response.data));
    },
    openform: function(opcao, id) {
      this.frmcadastro = true;
      this.erros = [];
      if (opcao == "novo") {
        this.excluir = false;
        this.titulo = "Novo Escritório";
        this.escritorio.nome = "";
        this.escritorio.telefone = "";
        this.escritorio.cnpj = "";
        this.escritorio.responsavel_id = 0;
        this.escritorio.anexo_cliente = false;
      } else if (opcao == "editar") {
        this.excluir = true;
        this.titulo = "Editar Escritório";

        this.$http
          .get(this.$urlAPI + "/escritorio/" + id, {
            headers: { authorization: "Bearer " + this.$store.getters.getToken }
          })
          .then(response => {
            this.escritorio = response.data;
            this.escritorio.anexo_cliente = this.escritorio.anexo_cliente == "1";
          });
      }
    },
    salvar: function() {
      this.escritorio.anexo_cliente = this.escritorio.anexo_cliente == true ? "1" : "0";
      if (this.excluir) {
        this.$http
          .post(
            this.$urlAPI + "/escritorio/" + this.escritorio.id,
            this.escritorio,
            {
              headers: {
                authorization: "Bearer " + this.$store.getters.getToken
              }
            }
          )
          .then(response => {
            if (response.data.status) {
              this.frmcadastro = false;
              this.getData();
            } else {
              this.erros = null;
              this.erros = response.data.erros;
            }
          })
          .catch(e => {
            this.erros = e.response.data.erros;
          });
      } else {
        this.$http
          .post(this.$urlAPI + "/escritorio", this.escritorio, {
            headers: { authorization: "Bearer " + this.$store.getters.getToken }
          })
          .then(response => {
            if (response.data.status) {
              this.frmcadastro = false;
              this.getData();
            } else {
              this.erros = null;
              this.erros = response.data.erros;
            }
          })
          .catch(e => {
            this.erros = e.response.data.erros;
          });
      }
    },
    confirmaExcluir: function() {
      this.exclusao = true;
    },
    deletar: function() {
      this.$http
        .delete(this.$urlAPI + "/escritorio/" + this.escritorio.id, {
          headers: { authorization: "Bearer " + this.$store.getters.getToken }
        })
        .then(response => {
          if (response.data.status) {
            this.frmcadastro = false;
            this.exclusao = false;
            this.getData();
          } else {
            this.erros = null;
            this.erros = response.data.erros;
          }
        })
        .catch(e => {
          this.erros = e.response.data.erros;
        });
    }
  }
};
</script>
